export function generateRGBA (r: string, g: string, b: string, a: string) {
  return `rgba(${r}, ${g}, ${b}, ${a})`;
}
